import { deleteCategory, getCategories } from "api/categories"
import React, { useState } from "react"
import { usePagination } from "../../../hooks/usePagination"
import DeleteModal from "components/Common/DeleteModal"
import ResultHandler from "components/ResultHandler"
import PaginationHandler from "components/PaginationHandler"
import TableHeaderHandler from "components/TableHeaderHandler"
import { PERMISSIONS } from "api/permissions"
import { useTranslation } from "react-i18next"
import { useResponse } from "hooks/useResponse"
import TableAction from "components/TableAction"
import EmptyData from "components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"

export default function CategoriesTable() {
  const { t } = useTranslation()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
  } = usePagination(getCategories)

  // delete

  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const { setData } = useResponse(deleteCategory, () => {
    setShow(false)
    setPayload({ txt: "" })
  })

  const [deletingCategory, setDeletingCategory] = useState(null)

  function onDeleteClick() {
    setData({ type: "add", data: deletingCategory })
  }

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.CATEGORY_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-category"
      />
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{ width: "30%" }}>{t("forms.Name")}</Th>
                <Th style={{ width: "10%" }}>{t("forms.Type")}</Th>
                <Th style={{ width: "10%" }}>{t("forms.Language")}</Th>

                <Th style={{ width: "20%" }}>{t("forms.Parent Category")}</Th>
                <Th style={{ width: "30%", textAlign: "center" }}>
                  {t("tables.Action")}
                </Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.categories.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.name}</Td>
                      <Td>
                        {row.is_internal
                          ? t("forms.Internal Category")
                          : t("forms.External Category")}
                      </Td>
                      <Td>{row.language === 'ar' ? "العربية" : "English"}</Td>
                      <Td>
                        {row.parentCategory
                          ? row.parentCategory.name
                          : t("forms.Not Found")}
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.CATEGORY_EDIT}
                          deletePermission={PERMISSIONS.CATEGORY_DELETE}
                          type="category"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingCategory}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.categories.length === 0}
              msg="No Categories Found."
            />
          )}
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}
          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  )
}
